import { inject } from '@angular/core';
import { Router } from '@angular/router';

import { environment } from '@pt/environment';

import { AdminFinancialRequestsService } from './admin-financial-requests-api.service';
import { FinancialRequestsMockService } from './financial-requests-api.mock.service';
import { UserFinancialRequestsService } from './user-financial-requests-api.service';

export function getFinancialRequestApi(router: Router) {
  if (environment.useMocks) {
    return inject(FinancialRequestsMockService);
  }

  return router.url.includes('admin')
    ? inject(AdminFinancialRequestsService)
    : inject(UserFinancialRequestsService);
}
